import { createSlice } from "@reduxjs/toolkit";
// CONTRACT REDUCER
const initialState = {
  manager: null,
  defaultFileStatus: null,
  defaultFolders: null,
  availableStatuses: null,
  registryRights: [],
  table: {
    search: "",
    limit: 11,
    page: 1,
    pages: 1,
    sort: "",
    data: [],
    searchFields: [
      { key: "shortName", name: "global:departments.shortName" },
      { key: "name", name: "global:departments.name" },
      { key: "leader", name: "global:departments.leader" },
    ],
    selectedSearchFields: ["shortName"],
    dictionaryFields: ["contractType"],
    url: "contract",
  },
};

const contractReducer = createSlice({
  name: "contractReducer",
  initialState,
  reducers: {
    updateManager: (state, { payload }) => {
      state.manager = payload;
    },
    setRegistryRights: (state, { payload }) => {
      state.registryRights = payload;
    },
    updateDefaultFileStatus: (state, { payload }) => {
      state.defaultFileStatus = payload;
    },
    updateDefaultFolders: (state, { payload }) => {
      state.defaultFolders = payload;
    },
    updateAvailableStatuses: (state, { payload }) => {
      state.availableStatuses = payload;
    },
    updateRegistry: (state, { payload }) => {
      state.table = { ...state.table, ...payload };
    },
    clearRegistry: () => initialState,
  },
  extraReducers: {},
});

export const {
  updateRegistry,
  clearRegistry,
  updateManager,
  updateDefaultFileStatus,
  updateDefaultFolders,
  updateAvailableStatuses,
  setRegistryRights,
} = contractReducer.actions;

export default contractReducer.reducer;
